import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EffectFeedbackInterface } from '.';
import { NAME, State } from './effect-feedback.reducer';

export const selectEffectFeedbackState = createFeatureSelector<State>(NAME);

export const getNext = createSelector(selectEffectFeedbackState, (state: State) => {
  const ids = ((state?.ids as string[]) ?? []) as string[];
  const entities = state?.entities ?? {};

  // only return the feedback with display true
  const filteredId = ids.find((id) => entities[id]?.display);

  if (!filteredId) {
    return;
  } else {
    return entities[filteredId];
  }
});

export const getNextSuccess = createSelector(getNext, (feedback: EffectFeedbackInterface) => {
  if (feedback && feedback.type === 'success') {
    return feedback;
  } else {
    return; // I want undefined to return
  }
});

export const getNextError = createSelector(getNext, (feedback: EffectFeedbackInterface) => {
  if (feedback && feedback.type === 'error') {
    return feedback;
  } else {
    return; // I want undefined to return
  }
});
export const getFeedbackForAction = createSelector(
  selectEffectFeedbackState,
  (state: State, props: { actionType: string }) => {
    const ids = ((state?.ids as string[]) ?? []) as string[];
    const entities = state?.entities ?? {};
    const filteredId = ids.find((id) => {
      return entities[id]?.triggerAction?.type === props.actionType;
    });
    return filteredId ? entities[filteredId] : undefined;
  }
);
export const getNextErrorFeedbackForActions = createSelector(
  selectEffectFeedbackState,
  (state: State, props: { actionTypes: string[] }) => {
    const ids = ((state?.ids as string[]) ?? []) as string[];
    const entities = state?.entities ?? {};
    const filteredIds = ids.filter(
      (id) =>
        props.actionTypes.some((actionType) => entities[id]?.triggerAction?.type === actionType) &&
        entities[id]?.type === 'error'
    );

    return filteredIds.length ? entities[filteredIds[0]] : undefined;
  }
);
